/* eslint-disable no-unused-vars */
import axios from '../axios';
import moment from 'moment';
import { get, map, xor } from 'lodash-es';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export function useSession1111(sessionId) {
  // const axios = useAxios();

  return useQuery(['chargingSession/details', sessionId], () =>
    axios.get(`/session/${sessionId}`).then((result) => result?.data?.data),
  );
}

export function useFetchAllCorporateSessions({
  query,
  type,
  filter = 'all',
  offset,
  limit,
  corporateId,
  startDate,
  endDate,
  enableSearch,
}) {
  // const axios = useAxios();
  const effectiveFilter = {
    all: {},
    active: { METER_STOP: 'null', END_TIME: 'null' },
  }[filter];
  let url = 'corporate/session';
  if (query) url += `?${type}=${query}`;
  return useQuery(
    [url, query, filter, offset, limit, startDate, endDate],
    () =>
      axios
        .get(url, {
          params: {
            ...effectiveFilter,
            offset,
            limit,
            startDate,
            endDate,
          },
        })
        .then((result) => {
          const resp = {
            list: get(result, 'data.data', []),
            total: get(result, 'data.count', 0),
          };
          if (result?.data?.status === 404) {
            resp['error'] = result?.data?.error;
          }
          return resp;
        }),
    {
      enabled: enableSearch,
    },
  );
}

export function useFetchCorporateSessionListByEmailOrName({
  query,
  type,
  filter = 'all',
  offset,
  limit,
  corporateId,
  startDate,
  endDate,
  enableSearch,
  emails,
  names,
}) {
  // const axios = useAxios();
  const effectiveFilter = {
    all: {},
    active: { METER_STOP: 'null', END_TIME: 'null' },
  }[filter];
  let url = 'corporate/session';
  // url += `?offset=${offset}&limit=${limit}`;
  return useQuery(
    [url, query, filter, offset, limit, startDate, endDate, emails, names],
    () =>
      axios
        .post(url, {
          ...effectiveFilter,
          offset,
          limit,
          startDate,
          endDate,
          emails,
          names,
        })
        .then((result) => {
          const resp = {
            list: get(result, 'data.data', []),
            total: get(result, 'data.count', 0),
          };
          if (result?.data?.status === 404) {
            resp['error'] = result?.data?.error;
          }
          return resp;
        }),
    {
      enabled: enableSearch,
    },
  );
}

export function useDownloadCorporateSessions({
  query,
  type,
  filter = 'all',
  offset,
  limit,
  corporateId,
  startDate,
  endDate,
  enableDownload,
  emails,
  names,
}) {
  const effectiveFilter = {
    all: {},
    active: { METER_STOP: 'null', END_TIME: 'null' },
  }[filter];
  let url = 'corporate/session';
  // url += `?offset=${offset}&limit=${limit}`;

  return useQuery(
    [url, query, filter, offset, limit, startDate, endDate, emails, names],
    () =>
      axios
        .post(url, {
          ...effectiveFilter,
          offset,
          limit,
          startDate,
          endDate,
          emails,
          names,
        })
        .then((result) => {
          const resp = {
            list: get(result, 'data.data', []),
            total: get(result, 'data.count', 0),
          };
          return resp;
        }),
    {
      enabled: enableDownload,
    },
  );

  // return useQuery(
  //   ['download', query, filter, offset, limit, startDate, endDate],
  //   () => {
  //     axios
  //       .get(url, {
  //         params: {
  //           ...effectiveFilter,
  //           offset,
  //           limit,
  //           startDate,
  //           endDate,
  //         },
  //       })
  //       .then((result) => {
  //         const response = {
  //           list: get(result, 'data.data', []),
  //           total: get(result, 'data.count', 0),
  //         };
  //         debugger;
  //         return response;
  //       });
  //   },
  //   {
  //     enabled: enableDownload,
  //   },
  // );
}

// export function useSessionListForMap({ filter = 'all' }) {
//   const axios = useAxios();

//   const effectiveFilter = {
//     all: {},
//     active: { METER_STOP: 'null', END_TIME: 'null' },
//   }[filter];

//   return useQuery(['chargingSession/listForMap', filter], () =>
//     axios
//       .get(`/sessionsForMap`, {
//         params: { ...effectiveFilter },
//       })
//       .then(result => ({
//         list: map(result?.data?.data, dat => ({
//           ...dat,
//           lat: dat?.latitude,
//           lng: dat?.longitude,
//         })),
//         total: get(result, 'data.count', 0),
//       })),
//   );
// }

export function useSessionListByCorporateCharger({
  CPID,
  offset,
  limit,
  month,
  year,
  query,
  type,
}) {
  let url = `/corporate/session?JP_CORPORATE_CHARGER.CHARGER=${CPID}`;
  if (query) url += `&${type}=${query}`;
  return useQuery(
    [
      'charger/chargingSession/list',
      CPID,
      offset,
      limit,
      query,
      type,
      month,
      year,
    ],
    () =>
      axios
        .get(url, {
          params: {
            CPID,
            offset,
            limit,
            month,
            year,
          },
        })
        .then((result) => {
          return {
            list: get(result, 'data.data', []),
            total: get(result, 'data.count', 0),
          };
        }),
    // {
    //   refetchInterval: 5000,
    // },
  );
}

// export function useTransactionLogsByTID({ cpid, tid }) {
//   const axios = useAxios();

//   return useQuery(['transactionLogs', cpid, tid], ({ queryKey }) => {
//     const [, chargerId, transactionId] = queryKey;
//     return (
//       axios
//         .get(`/transactionLogs/${chargerId}/${transactionId}`)
//         .then(res => res.data),
//       {
//         enabled: cpid && tid,
//       }
//     );
//   });
// }

export function useSessionByQueueId(qId) {
  // const axios = useAxios();

  return useQuery(['session/?QUEUEID', qId], () =>
    axios.get(`/corporate/session?QUEUEID=${qId}`).then((result) => {
      if (result?.data?.data?.length > 0) {
        return result?.data?.data[0];
      } else {
        return result?.data?.data;
      }
    }),
  );
}

export function useFetchCorporateSessionsByUserId({ userId, offset, limit }) {
  // const axios = useAxios();

  return useQuery(['corporate/session', userId, offset, limit], () =>
    axios
      .get(`corporate/session`, {
        params: {
          'CUSTOMERS.ID': userId,
          offset,
          limit,
        },
      })
      .then((result) => {
        const resp = {
          list: get(result, 'data.data', []),
          total: get(result, 'data.count', 0),
        };
        return resp;
      }),
  );
}

// Remote Stop Charging
export function useStopCharging() {
  return useMutation(
    // eslint-disable-next-line no-unused-vars
    ({ queueId }) => axios.post(`/corporate/stopCharging/${queueId}`, {}),
    {
      onSuccess: (data, variables) => {
        return data;
      },
    },
  );
}
